module.exports = __webpack_public_path__ + "static/img/aqzs46.3d6ba4b2.jpg";